export const errors = {
  nameRequired: 'Name is required.',
  descriptionRequired: 'Description is required.',
  valuePropsRequired: 'At least one value prop is required.',
  differentiatorsRequired: 'At least one differentiator is required.',
  competingProductsRequired: 'At least one competing product is required.',
};
